// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/form/v1/form.proto" (package "c1.api.form.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { FormSchemaService } from "./form";
import type { FormSchemaServiceSearchResponse } from "./form";
import type { FormSchemaServiceSearchRequest } from "./form";
import type { FormSchemaServiceDeleteResponse } from "./form";
import type { FormSchemaServiceDeleteRequest } from "./form";
import type { FormSchemaServiceUpdateResponse } from "./form";
import type { FormSchemaServiceUpdateRequest } from "./form";
import type { FormSchemaServiceListResponse } from "./form";
import type { FormSchemaServiceListRequest } from "./form";
import type { FormSchemaServiceGetResponse } from "./form";
import type { FormSchemaServiceGetRequest } from "./form";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { FormSchemaServiceCreateResponse } from "./form";
import type { FormSchemaServiceCreateRequest } from "./form";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.form.v1.FormSchemaService
 */
export interface IFormSchemaServiceClient {
    /**
     * Create a new form schema
     *
     * @generated from protobuf rpc: Create(c1.api.form.v1.FormSchemaServiceCreateRequest) returns (c1.api.form.v1.FormSchemaServiceCreateResponse);
     */
    create(input: FormSchemaServiceCreateRequest, options?: RpcOptions): UnaryCall<FormSchemaServiceCreateRequest, FormSchemaServiceCreateResponse>;
    /**
     * Get a form schema by ID
     *
     * @generated from protobuf rpc: Get(c1.api.form.v1.FormSchemaServiceGetRequest) returns (c1.api.form.v1.FormSchemaServiceGetResponse);
     */
    get(input: FormSchemaServiceGetRequest, options?: RpcOptions): UnaryCall<FormSchemaServiceGetRequest, FormSchemaServiceGetResponse>;
    /**
     * List form schemas
     *
     * @generated from protobuf rpc: List(c1.api.form.v1.FormSchemaServiceListRequest) returns (c1.api.form.v1.FormSchemaServiceListResponse);
     */
    list(input: FormSchemaServiceListRequest, options?: RpcOptions): UnaryCall<FormSchemaServiceListRequest, FormSchemaServiceListResponse>;
    /**
     * Update a form schema
     *
     * @generated from protobuf rpc: Update(c1.api.form.v1.FormSchemaServiceUpdateRequest) returns (c1.api.form.v1.FormSchemaServiceUpdateResponse);
     */
    update(input: FormSchemaServiceUpdateRequest, options?: RpcOptions): UnaryCall<FormSchemaServiceUpdateRequest, FormSchemaServiceUpdateResponse>;
    /**
     * Delete a form schema
     *
     * @generated from protobuf rpc: Delete(c1.api.form.v1.FormSchemaServiceDeleteRequest) returns (c1.api.form.v1.FormSchemaServiceDeleteResponse);
     */
    delete(input: FormSchemaServiceDeleteRequest, options?: RpcOptions): UnaryCall<FormSchemaServiceDeleteRequest, FormSchemaServiceDeleteResponse>;
    /**
     * Search form schemas
     *
     * @generated from protobuf rpc: Search(c1.api.form.v1.FormSchemaServiceSearchRequest) returns (c1.api.form.v1.FormSchemaServiceSearchResponse);
     */
    search(input: FormSchemaServiceSearchRequest, options?: RpcOptions): UnaryCall<FormSchemaServiceSearchRequest, FormSchemaServiceSearchResponse>;
}
/**
 * @generated from protobuf service c1.api.form.v1.FormSchemaService
 */
export class FormSchemaServiceClient implements IFormSchemaServiceClient, ServiceInfo {
    typeName = FormSchemaService.typeName;
    methods = FormSchemaService.methods;
    options = FormSchemaService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Create a new form schema
     *
     * @generated from protobuf rpc: Create(c1.api.form.v1.FormSchemaServiceCreateRequest) returns (c1.api.form.v1.FormSchemaServiceCreateResponse);
     */
    create(input: FormSchemaServiceCreateRequest, options?: RpcOptions): UnaryCall<FormSchemaServiceCreateRequest, FormSchemaServiceCreateResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<FormSchemaServiceCreateRequest, FormSchemaServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a form schema by ID
     *
     * @generated from protobuf rpc: Get(c1.api.form.v1.FormSchemaServiceGetRequest) returns (c1.api.form.v1.FormSchemaServiceGetResponse);
     */
    get(input: FormSchemaServiceGetRequest, options?: RpcOptions): UnaryCall<FormSchemaServiceGetRequest, FormSchemaServiceGetResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<FormSchemaServiceGetRequest, FormSchemaServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List form schemas
     *
     * @generated from protobuf rpc: List(c1.api.form.v1.FormSchemaServiceListRequest) returns (c1.api.form.v1.FormSchemaServiceListResponse);
     */
    list(input: FormSchemaServiceListRequest, options?: RpcOptions): UnaryCall<FormSchemaServiceListRequest, FormSchemaServiceListResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<FormSchemaServiceListRequest, FormSchemaServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update a form schema
     *
     * @generated from protobuf rpc: Update(c1.api.form.v1.FormSchemaServiceUpdateRequest) returns (c1.api.form.v1.FormSchemaServiceUpdateResponse);
     */
    update(input: FormSchemaServiceUpdateRequest, options?: RpcOptions): UnaryCall<FormSchemaServiceUpdateRequest, FormSchemaServiceUpdateResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<FormSchemaServiceUpdateRequest, FormSchemaServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete a form schema
     *
     * @generated from protobuf rpc: Delete(c1.api.form.v1.FormSchemaServiceDeleteRequest) returns (c1.api.form.v1.FormSchemaServiceDeleteResponse);
     */
    delete(input: FormSchemaServiceDeleteRequest, options?: RpcOptions): UnaryCall<FormSchemaServiceDeleteRequest, FormSchemaServiceDeleteResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<FormSchemaServiceDeleteRequest, FormSchemaServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Search form schemas
     *
     * @generated from protobuf rpc: Search(c1.api.form.v1.FormSchemaServiceSearchRequest) returns (c1.api.form.v1.FormSchemaServiceSearchResponse);
     */
    search(input: FormSchemaServiceSearchRequest, options?: RpcOptions): UnaryCall<FormSchemaServiceSearchRequest, FormSchemaServiceSearchResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<FormSchemaServiceSearchRequest, FormSchemaServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
}
